import { EventAggregator } from 'aurelia';
import { inject } from 'aurelia';

import { CamelCaseValueConverter } from '../resources/value-converters/camel-case';

import { ApiService } from './api-service';
import { SessionService } from './session-service';

@inject(ApiService, SessionService, EventAggregator, CamelCaseValueConverter)
export class IpAddressService {
    path = 'IpAddress';
    private ipDataPromise: Promise<any> | null = null;

    constructor(private api: ApiService, private sessionService: SessionService, private eventAggregator: EventAggregator, private camelCaseValueConverter: CamelCaseValueConverter) {}

    async postIp() {
        try {
            const response = await this.api.doPost<any>(this.path, {});
            this.eventAggregator.publish('vpn-detection', { vpn: response.vpn, tor: response.tor, ip: response.ip });
            await this.saveUserProxy(response);
            await this.saveGeoLocation(response);
            return response;
        } catch (error) {
            console.error('Error fetching IP data:', error);
            return null;
        }
    }

    async getIpData() {
        if (this.sessionService.geolocation) {
            return this.sessionService.geolocation;
        }

        if (this.ipDataPromise) {
            return this.ipDataPromise;
        }

        try {
            this.ipDataPromise = this.api.doGet<any>(`${this.path}/GetIpData`);
            const response = await this.ipDataPromise;
            if (response) {
                await this.saveGeoLocation(response);
            }
            return response;
        } catch (error) {
            console.error('Error fetching IP data:', error);
            return null;
        } finally {
            this.ipDataPromise = null;
        }
    }

    async saveGeoLocation(geolocation) {
        if (geolocation) {
            this.sessionService.geolocation = geolocation;
            this.eventAggregator.publish('geolocation-updated', { geolocation });
        }
    }

    async saveUserProxy(userProxy) {
        this.sessionService.userProxy = userProxy;
    }
}
